import useAPI from '@/hooks/useAPI';
import ChecklistRepository from '@/repositories/ChecklistCategoryRepository';
import type { ChecklistCategoryParams } from '@/types/checklistCategory';

export const useChecklistCategories = (params: ChecklistCategoryParams, enabled = true) => {
  const checklistRepository = ChecklistRepository();

  return useAPI({
    queryKey: ['getChecklistCategories', params],
    queryFn: async () => {
      return await checklistRepository.getChecklists(params);
    },
    enabled: enabled && !!params.person_id
  });
};

export default useChecklistCategories;
